import { PATCH_TOKEN } from '../constants/actionTypes';

const initialState = {
  sanityAdminToken: {}
};

// eslint-disable-next-line
export default (state = initialState, action) => {
  switch (action.type) {
    case PATCH_TOKEN.SUCCESS:
      return {
        ...state,
        sanityAdminToken: action.obj
      };
    default:
      return state;
  }
};
